import { render, staticRenderFns } from "./Menu.vue?vue&type=template&id=a65ce0d4&scoped=true"
import script from "./Menu.vue?vue&type=script&lang=ts"
export * from "./Menu.vue?vue&type=script&lang=ts"
import style0 from "@/assets/css/scoped/menu-style.css?vue&type=style&index=0&id=a65ce0d4&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a65ce0d4",
  null
  
)

/* custom blocks */
import block0 from "@/assets/locales/i18n-menu.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fbuilds%2Ftses-smartregion%2Fstadtkarte%2Fuis%2Fproficontrol-ui%2Fsrc%2Fcomponents%2FMenu.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports